import { useState } from "react";
import { Link } from "react-router-dom";
import ForgotSvg from "../../assets/img/forgot.svg";
import { useFormik } from "formik";
import * as Yup from "yup";
import request from "../../shared/utils/request";
import { FormError } from "../../shared/components/validationMessage";
import { LoadingButton } from "../../shared/components/loadingButton";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ForgotPassword = () => {
  const [loader, setLoader] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        const response = await request.post("forgotPassword", values);
        if (response?.data?.success) {
          toast.success(response?.data?.message, {
            autoClose: 4000,
          });
          formik.resetForm();
        } else {
          toast.error(response?.data?.message, {
            autoClose: 4000,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    },
  });

  return (
    <section id="login-container">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-5">
            <img src={ForgotSvg} className="img-fluid" alt="" />
          </div>
          <div className="col-md-7">
            <div className="login-Card">
              <h1 className="text-center py-3">Forgot Password</h1>
              <p className="text-center">
                <i>Just provide your email and we can do the rest </i>
              </p>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1">Email address</label>
                  <br />
                  <small id="emailHelp" className="form-text text-muted">
                    We'll never share your email with anyone else.
                  </small>
                  <input
                    type="email"
                    className="form-control eduform"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    placeholder="Enter email"
                    {...formik.getFieldProps("email")}
                  />
                  <FormError
                    touched={formik.touched.email}
                    error={formik.errors.email}
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <LoadingButton isLoading={loader} buttonText={"Submit"} />
                </div>
                <div className="d-flex justify-content-center py-4">
                  <p>
                    Did you remember? &nbsp;<Link to={"/"}>Login</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
